// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".manageRange[data-v-67c33a87]{width:100%;max-height:120px;overflow-x:hidden}.manageRange[data-v-67c33a87] .el-select__tags{max-height:120px!important}", ""]);
// Exports
module.exports = exports;
